// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Crsh","title":"Header_title__3T3o6","side":"Header_side__2HnKg"};